/**
 * orga-app-api - pandemie-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PandemieLevel { 
    disabled?: boolean;
    level_id?: number;
    bezeichnung: string;
    farbe: string;
    anzeige: string;
    icon: string;
    reihenfolge?: number;
}

